import React from 'react'

import { CATEGORY_MAP } from 'constants/travelsafe'

import { ReactComponent as Boarding } from 'assets/icons/boarding.svg'
import { ReactComponent as NoEntry } from 'assets/icons/no_entry_exit.svg'
import { ReactComponent as Quarantine } from 'assets/icons/quarantine.svg'
import { ReactComponent as Covid } from 'assets/icons/covid.svg'
import { ReactComponent as Deposit } from 'assets/icons/deposit.svg'
import { ReactComponent as Doc } from 'assets/icons/doc.svg'
import { ReactComponent as Entry } from 'assets/icons/entry_exit.svg'
import { ReactComponent as Restricted } from 'assets/icons/restricted.svg'
import { ReactComponent as Visa } from 'assets/icons/visa.svg'
import { ReactComponent as Sanitization } from 'assets/icons/sanitization.svg'
import { ReactComponent as HealthMeasure } from 'assets/icons/health_measure.svg'
import { ReactComponent as Mask } from 'assets/icons/mask.svg'
import { ReactComponent as Info } from 'assets/icons/info.svg'

function IconMap({ icon, ...props }) {
	switch (icon) {
		case CATEGORY_MAP.NO_ENTRY:
			return <NoEntry {...props} />
		case CATEGORY_MAP.NO_EXIT:
			return <NoEntry {...props} />
		case CATEGORY_MAP.ENTRY:
			return <Entry {...props} />
		case CATEGORY_MAP.EXIT:
			return <Entry {...props} />
		case CATEGORY_MAP.RESTRICTED_ENTRY:
			return <Restricted {...props} />
		case CATEGORY_MAP.RESTRICTED_EXIT:
			return <Restricted {...props} />
		case CATEGORY_MAP.BOARDING:
			return <Boarding {...props} />
		case CATEGORY_MAP.TRANSIT:
			return <Boarding {...props} />
		case CATEGORY_MAP.QUARANTINE:
			return <Quarantine {...props} />
		case CATEGORY_MAP.DOC_REQUIRED:
			return <Doc {...props} />
		case CATEGORY_MAP.PPE:
			return <Mask {...props} />
		case CATEGORY_MAP.COVID_19_TEST:
			return <Covid {...props} />
		case CATEGORY_MAP.HEALTH_MEASURES:
			return <HealthMeasure {...props} />
		case CATEGORY_MAP.SANITIZATION:
			return <Sanitization {...props} />
		case CATEGORY_MAP.RE_ENTRY_PERMIT:
			return <Doc {...props} />
		case CATEGORY_MAP.DEPOSIT_REQUIRED:
			return <Deposit {...props} />
		case CATEGORY_MAP.HEALTH_ASSESSMENT:
			return <HealthMeasure {...props} />
		case CATEGORY_MAP.DEFAULT:
			return <Info {...props} />
		case CATEGORY_MAP.VISA:
			return <Visa {...props} />
		default:
			return <Info {...props} />
	}
}

IconMap.defaultProps = {
	icon: CATEGORY_MAP.DEFAULT,
}

export default IconMap
